import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/theme/Theme.module_built.css";
const classes = {"theme":"w2roZmq_theme","variant-copilot":"w2roZmq_variant-copilot"}
export default classes

const _theme0 = classes["theme"]
export { _theme0 as "theme" }

const _variant_copilot0 = classes["variant-copilot"]
export { _variant_copilot0 as "variant-copilot" }
